import { Typography } from '@mui/material';
import ActionButton from '@source/components/ActionButton';
import getPixelRatio from '@source/utils/getPixelRatio';
import router from 'next/router';
import { useEffect, useState } from 'react';
import * as S from './styles';

type ImageSize = {
  width: number;
  height: number;
};

const CreateEventHero: React.FC = (): JSX.Element => {
  const [imageSize, setImageSize] = useState<ImageSize | undefined>();
  const [imageBoxWidth, setImageBoxWidth] = useState<number>(300);

  useEffect(() => {
    if (window !== undefined) {
      const innerWidth = window.innerWidth;

      const mediumBreakPoint = 768;

      if (innerWidth < mediumBreakPoint) {
        const imageHeight = innerWidth / 1.2;

        setImageSize({ height: imageHeight, width: innerWidth });
        return;
      }

      const imageWidth = innerWidth / 2;

      const imageHeight = imageWidth / 1.2;

      setImageSize({ height: imageHeight, width: imageWidth });
    }
  }, []);

  const imageUrl = `assets/web/img/organizer-main.jpg`;

  const redirectToWizard = () => router.push('/create-challenge');

  return (
    <S.Container>
      {imageSize?.width && (
        <S.ImageBox
          width={imageSize?.width}
          height={imageBoxWidth * 0.7}
          ref={ref => ref && setImageBoxWidth(ref.clientWidth)}
        >
          <S.CustomImage
            src={`/${imageUrl}?wdt=${getPixelRatio(imageSize.width)}`}
            loader={({ src }) => `${process.env.NEXT_PUBLIC_CDN_URL}${src}`}
            layout="fill"
            alt="Sua próxima prova de ciclismo começa aqui"
            title="Sua próxima prova de ciclismo começa aqui"
            priority
            blurDataURL={`${process.env.NEXT_PUBLIC_CDN_URL}/${imageUrl}?wdt=150&hgt=150`}
            placeholder="blur"
          />
        </S.ImageBox>
      )}

      <S.InnerBox>
        <Typography
          sx={{
            fontSize: {
              xs: '2rem',
              sm: '3rem',
              md: '4.8rem'
            },
            fontWeight: 600
          }}
        >
          {'Sua próxima prova de ciclismo começa aqui'}
        </Typography>

        <S.Text>
          {'Você gerencia sua prova do celular ou computador, como quiser.'}
        </S.Text>

        <S.ButtonsBox>
          <ActionButton
            label="Crie o primeiro, é fácil"
            labelcolor="blue"
            style={{ width: '100%' }}
            onClick={redirectToWizard}
          />
        </S.ButtonsBox>
      </S.InnerBox>
    </S.Container>
  );
};

export default CreateEventHero;
